import * as React from 'react';

interface IFormSelectProps extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
	widthtype?: 'normal' | 'wide';
	'is-valid'?: 'true' | 'false';
}

interface IFormSelectState {
	open: boolean;
}

export class FormSelect extends React.Component<IFormSelectProps, IFormSelectState> {
	public render() {
		const { children, ...props } = this.props;
		const containerClassList = ['form-select'];
		const classList = ['form-select__element'];

		containerClassList.push(`form-select--container${this.props.widthtype ? `--${this.props.widthtype}` : ''}`);

		if (this.props.disabled) {
			containerClassList.push('form-select--disabled');
		}

		if (this.props['is-valid'] === 'false') {
			classList.push('form-select__error');
		}

		return <div className={containerClassList.join(' ')}>
			<select className={classList.join(' ')} {...props}>{children}</select>
		</div>;
	}
}
